import React, { Component, Fragment } from 'react'
import OverviewHeader from './OverviewHeader'
import OverviewTable from './OverviewTable'
import { inject, observer } from "mobx-react"
import Cookies from "js-cookie";


@inject('HeaderStore', 'RiderStore')
@observer
class Overview extends Component {
  componentDidMount() {
    const { HeaderStore, RiderStore } = this.props
    HeaderStore.header = 'overview'
    RiderStore.getRidersCheckedIn(Cookies.get('token'))    
  }
  render() {
    return(
      <Fragment>
        <OverviewHeader />
        <OverviewTable />
      </Fragment>
    )
  }
}

export default Overview


// WEBPACK FOOTER //
// ./src/components/overview/Overview.js